import { DTOFigmaNode, DTOFigmaNodeV2 } from "./figma-nodes";
import { z } from "zod";
//
// Read
//
export const DTOElementsGetTypeFilter = z.enum(["FigmaNode"]);
export const DTOElementsGetQuerySchema = z.object({
    types: z
        .string()
        .transform((val) => val.split(",").map((v) => DTOElementsGetTypeFilter.parse(v))),
    responseVersion: z.coerce.number().default(1),
});
export const DTOElementsGetOutput = z.object({
    figmaNodes: z.array(DTOFigmaNode).optional(),
});
export const DTOElementsGetOutputV2 = z.object({
    figmaNodes: z.array(DTOFigmaNodeV2).optional(),
});
